const NAME = 'rep';

export const REP_TASK_SUBPAGES = [
  'access',
  'comments',
  'complete',
  'cost',
  'details',
  'issues',
  'notes',
  'photos',
  'requirements',
  'summary',
  'supplies',
];

export const TABS_TYPE = {
  ALL: 'all',
  ITEMIZED: 'itemized',
  PENDING: 'pending',
  TOTAL: 'total',
};

export const TABS = [
  {
    code: 'total',
    name: 'TOTAL COST',
  },
  {
    code: 'itemized',
    name: 'ITEMIZED COST',
  },
];

export const ITEMIZED_TYPES = [
  { value: 'labor', label: 'Labor' },
  { value: 'material', label: 'Material' },
  { value: 'expense', label: 'Expense' },
  { value: 'tax', label: 'Tax' },
  { value: 'skilled_labor', label: 'Skilled labor' },
  { value: 'non_skilled_labor', label: 'Non-skilled labor' },
  { value: 'mileage', label: 'Mileage' },
  { value: 'mark_up', label: 'Mark-up' },
];

export default {
  ITEMIZED_TYPES,
  NAME,
  REP_TASK_SUBPAGES,
  TABS_TYPE,
  TABS,
};
